import createSliders from './create-slider.js';
import SwiperCore, { Pagination, Navigation, Lazy } from './swiper/swiper-bundle.js';

SwiperCore.use([Pagination, Navigation, Lazy]);

function init() {
    const thumbsOptions = {
        loop: false,
        preloadImages: false,
        lazy: true,
        spaceBetween: 5,
        freeMode: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        slidesPerView: 4,
        breakpoints: {
            671: {
                slidesPerView: 9,
            },
        },
    };

    const thumbsSlider = new SwiperCore('.js_thumbsSlider', thumbsOptions);

    const options = {
        slidesPerView: 1,
        watchOverflow: true,
        watchSlidesProgress: true,
        preloadImages: false,
        lazy: true,
        thumbs: {
            swiper: thumbsSlider,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'thumbsSlider__slide--active',
        },
    };

    createSliders('js_imageGallerySlider', options);
}

$(document).ready(init);
